<div class="rbac-container">
    <h2>Manage Role Access</h2>
  
    <label for="role-select">Select Role:</label>
    <select id="role-select" [(ngModel)]="selectedRole" (change)="selectRole(selectedRole!)">
      <option *ngFor="let role of roles" [value]="role">{{ role }}</option>
    </select>
  
    <div *ngIf="selectedRole">
      <h3>Permissions for: {{ selectedRole }}</h3>
  
      <div *ngIf="unsavedChanges" class="warning">
        <em>You have unsaved changes.</em>
      </div>
  
      <div *ngFor="let route of routeOptions; trackBy: trackByRoute">
        <label>
          <input
            type="checkbox"
            [checked]="selectedRoutes.includes(route)"
            (change)="toggleRoute(route)"
          />
          {{ route }}
        </label>
      </div>
      
  
      <div class="button-group">
        <button (click)="save()">💾 Save</button>
        <button (click)="delete()" class="danger">🗑️ Delete Role</button>
      </div>
    </div>
  </div>
  